<div class="preview-dialog-container">
  <h2 class="h2">Receipt Preview</h2>
  <div [innerHTML]="previewContent" class="preview-container"></div> <!-- Render the HTML content -->
  <button class="custom-blue-button" (click)="closeDialog()">Close</button>
</div>
